import {
  CREATE_FORTNIGHTLY,
  DATA_DELETED,
  GET_FORTNIGHTLY_WEEKS,
  GET_FORTNIGHTLY_YEARS,
} from '../types';
import { get, post, remove } from './Action';

const basePath = '/fortnightly';

//Get all fortnightlys
export const getAllYears = () => async (dispatch) => {
  return await dispatch(get(`${basePath}/get-years`, getAllYearsDS, true));
};

export const createFortnightly = (fortnightly) => async (dispatch) => {
  const response = await dispatch(
    post(`${basePath}/create`, fortnightly, createFortnightlyDS)
  );
  return response;
};

export const deleteFortnightlys = (id) => async (dispatch) => {
  const response = await dispatch(
    remove(`${basePath}/${id}/delete`, deleteFortnightlysDS)
  );
  dispatch(deleteFortnightlysDS(id));
  return response;
};

export const getAllWeeksByYear = (id) => async (dispatch) => {
  return await dispatch(
    get(`${basePath}/${id}/get-weeks`, getAllWeeksDS, true)
  );
};

export const getWeeksOnlyYear = (year) => async (dispatch) => {
  return await dispatch(
    get(`${basePath}/${year}/get-weeks-by-year`, getAllWeeksDS, true)
  );
};

const getAllYearsDS = (fortnightly) => ({
  type: GET_FORTNIGHTLY_YEARS,
  payload: fortnightly,
});

const getAllWeeksDS = (fortnightlyWeeks) => ({
  type: GET_FORTNIGHTLY_WEEKS,
  payload: fortnightlyWeeks,
});

const createFortnightlyDS = (fortnightly) => ({
  type: CREATE_FORTNIGHTLY,
  payload: fortnightly,
});

export const deleteFortnightlysDS = (id) => ({
  type: DATA_DELETED,
  payload: id,
});
